// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.save-list-container {
  background-color: #FFFFFF;
  border: 1px solid #c3c8ca;
  border-radius: 10px;
  box-shadow: 0 9px 25px rgba(129, 155, 163, 0.27);
  height: 220px;
  padding: 30px;
  width: 400px;
  overflow: hidden;
}
.save-list-container .save-list-title {
  font-size: 26px;
  font-weight: bold;
  padding: 0 0 10px 0;
}
.save-list-container .save-list-subtitle {
  color: #365A64;
  font-size: 14px;
  padding: 0 0 20px 0;
}
.save-list-container .save-list-field {
  font-size: 16px;
  padding-right: 10px;
}
.save-list-container .save-list-button {
  background-color: #40A0C1;
  font-size: 18px;
  outline: none;
  padding: 7px 16px;
  border-radius: 20px;
  border: 0;
  color: white;
  cursor: pointer;
  white-space: nowrap;
}
.save-list-container .save-list-input {
  background-color: #FFFFFF;
  border: 1px solid #D3E1ED;
  border-radius: 5px;
  padding: 6px;
  margin-bottom: 10px;
  width: 100%;
  outline: none;
  resize: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Mapping/SaveListModal/SaveListModal.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gDAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AACD;AACC;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;AACF;AAEC;EACC,cAAA;EACA,eAAA;EACA,mBAAA;AAAF;AAGC;EACC,eAAA;EACA,mBAAA;AADF;AAIC;EACC,yBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAFF;AAKC;EACC,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;AAHF","sourcesContent":[".save-list-container {\n\tbackground-color: #FFFFFF;\n\tborder: 1px solid #c3c8ca;\n\tborder-radius: 10px;\n\tbox-shadow: 0 9px 25px rgba(129, 155, 163, 0.27);\n\theight: 220px;\n\tpadding: 30px;\n\twidth: 400px;\n\toverflow: hidden;\n\n\t.save-list-title {\n\t\tfont-size: 26px;\n\t\tfont-weight: bold;\n\t\tpadding: 0 0 10px 0;\n\t}\n\n\t.save-list-subtitle {\n\t\tcolor: #365A64;\n\t\tfont-size: 14px;\n\t\tpadding: 0 0 20px 0;\n\t}\n\n\t.save-list-field {\n\t\tfont-size: 16px;\n\t\tpadding-right: 10px;\n\t}\n\n\t.save-list-button {\n\t\tbackground-color: #40A0C1;\n\t\tfont-size: 18px;\n\t\toutline: none;\n\t\tpadding: 7px 16px;\n\t\tborder-radius: 20px;\n\t\tborder: 0;\n\t\tcolor: white;\n\t\tcursor: pointer;\n\t\twhite-space: nowrap;\n\t}\n\n\t.save-list-input {\n\t\tbackground-color: #FFFFFF;\n\t\tborder: 1px solid #D3E1ED;\n\t\tborder-radius: 5px;\n\t\tpadding: 6px;\n\t\tmargin-bottom: 10px;\n\t\twidth: 100%;\n\t\toutline: none;\n\t\tresize: none;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
